import { createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../api";
import { addNotification } from "../../Notification/notificateStore";
import { apiUrlV1 } from "../../../config/config";
import { IGlobalProfile, ITranslationProfile, IWheelConfige, WheelProfileGlobal, WheelProfileReward, WheelProfileRewards } from "../../../entities/wheelGame";

const DEFAULT_URL_V2 = `${apiUrlV1}/v2/organization/game/fortunewheel`;

export const getWheelProfileThemes = createAsyncThunk(
  'wheel/get-themes',
  async (): Promise<string[]> => {
    try {
      const response = await agent.get(`${DEFAULT_URL_V2}/profile/theme-list`);

      if (response.ok) {
        const data = await response.json();
        return data.themes;
      }

      return []
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)

export const postWheelProfile = createAsyncThunk(
  "wheel/post-wheel-profile",
  async (params: { data: IGlobalProfile }, thunksApi) => {
    try {
      const response = await agent.post(`${DEFAULT_URL_V2}/profile`, {
        body: JSON.stringify(params.data),
      });

      if (response.ok) {
        const data = await response.json();
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        return data;
      }
      if (!response.ok) {
        const result = await response.json() as { message: string }
        thunksApi.dispatch(addNotification({ status: 'error', text: result.message }))
        throw result.message;
      }

      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);

export const getWheelProfile = createAsyncThunk(
  "wheel/get-wheel-profile",
  async (params: { id: number }, thunksApi): Promise<WheelProfileGlobal> => {
    try {
      const response = await agent.get(`${DEFAULT_URL_V2}/profile/${params.id}`);

      if (response.ok) {
        const data = await response.json();
        return data;
      }

      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);

export const patchWheelProfile = createAsyncThunk(
  "wheel/patch-wheel-profile",
  async (params: { data: IGlobalProfile }, thunksApi) => {
    try {
      const response = await agent.patch(`${DEFAULT_URL_V2}/profile/${params.data.id}`, {
        body: JSON.stringify(params.data),
      });

      if (response.ok) {
        const data = await response.json();
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        return data;
      }
      if (!response.ok) {
        const result = await response.json() as { message: string }
        thunksApi.dispatch(addNotification({ status: 'error', text: result.message }))
        throw result.message;
      }

      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);

export const getWheelProfileConfiguration = createAsyncThunk(
  "wheel/get-wheel-profile-configuration",
  async (params: { id: number }, thunksApi): Promise<IWheelConfige[]> => {
    try {
      const response = await agent.get(`${DEFAULT_URL_V2}/profile/config/list?profileId=${params.id}`);

      if (response.ok) {
        const data = await response.json();
        return data;
      }

      return [];
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);

export const postWheelProfileConfiguration = createAsyncThunk(
  "wheel/post-wheel-profile-configuration",
  async (params: { data: IWheelConfige[], profileId: number }, thunksApi): Promise<IWheelConfige[]> => {
    try {
      const response = await agent.post(`${DEFAULT_URL_V2}/profile/config/${params.profileId}`, {
        body: JSON.stringify({ configList: params.data })
      });

      if (response.ok) {
        const data = await response.json() as IWheelConfige[];
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        return data;
      }

      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);
export const patchWheelProfileConfiguration = createAsyncThunk(
  "wheel/patch-wheel-profile-configuration",
  async (params: { data: IWheelConfige[], profileId: number }, thunksApi): Promise<IWheelConfige[]> => {
    try {
      const response = await agent.patch(`${DEFAULT_URL_V2}/profile/config/${params.profileId}`, {
        body: JSON.stringify({ configList: params.data })
      });

      if (response.ok) {
        const data = await response.json() as IWheelConfige[];
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        return data;
      }

      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);

export const getWheelProfilePopup = createAsyncThunk(
  "wheel/get-wheel-profile-popup",
  async (params: { id: number }, thunksApi): Promise<ITranslationProfile[]> => {
    try {
      const response = await agent.get(`${DEFAULT_URL_V2}/profile/translation/list/${params.id}`);

      if (response.ok) {
        const data = await response.json();
        return data;
      }

      return [];
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);

export const postWheelProfilePopup = createAsyncThunk(
  "wheel/post-wheel-profile-popup",
  async (params: { data: ITranslationProfile, id: number }, thunksApi): Promise<ITranslationProfile[]> => {
    try {
      const response = await agent.post(`${DEFAULT_URL_V2}/profile/translation/${params.id}`, {
        body: JSON.stringify(params.data)
      });

      if (response.ok) {
        const data = await response.json();
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        return data;
      }

      return [];
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);

export const patchWheelProfilePopup = createAsyncThunk(
  "wheel/patch-wheel-profile-popup",
  async (params: { data: ITranslationProfile, id: number }, thunksApi): Promise<ITranslationProfile[]> => {
    try {
      const response = await agent.patch(`${DEFAULT_URL_V2}/profile/translation/${params.id}`, {
        body: JSON.stringify(params.data)
      });

      if (response.ok) {
        const data = await response.json();
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        return data;
      }

      return [];
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);
export const getWheelProfileReward = createAsyncThunk(
  "wheel/get-wheel-profile-reward",
  async (params: { id: number }, thunksApi): Promise<WheelProfileReward> => {
    try {
      const responseGlobalReward = await agent.get(`${DEFAULT_URL_V2}/profile/reward-page/${params.id}`);

      const responseTranslationReward = await agent.get(`${DEFAULT_URL_V2}/profile/reward-page-translation/list/${params.id}`);

      if (responseGlobalReward.ok && responseTranslationReward.ok) {
        const data = await responseGlobalReward.json();
        const rewards = await responseTranslationReward.json()
        return { ...data, rewards };
      }

      if (!responseGlobalReward.ok && responseTranslationReward.ok) {
        const rewards = await responseTranslationReward.json()
        return {
          config: {
            isEnabled: false,
            url: ""
          }, rewards
        };
      }

      return {
        config: {
          isEnabled: false,
          url: ""
        },
        rewards: []
      };
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);

export const patchWheelProfileReward = createAsyncThunk(
  "wheel/patch-wheel-profile-reward",
  async (params: {
    data: {
      config: {
        url: string,
        isEnabled: boolean
      },
    }, id: number
  }, thunksApi): Promise<ITranslationProfile[]> => {
    try {
      const response = await agent.patch(`${DEFAULT_URL_V2}/profile/reward-page/${params.id}`, {
        body: JSON.stringify(params.data)
      });

      if (response.ok) {
        const data = await response.json();
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        return data;
      }

      return [];
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);

export const postWheelProfileReward = createAsyncThunk(
  "wheel/post-wheel-profile-reward",
  async (params: {
    data: {
      config: {
        url: string,
        isEnabled: boolean
      },
    }, id: number
  }, thunksApi): Promise<ITranslationProfile[]> => {
    try {
      const response = await agent.post(`${DEFAULT_URL_V2}/profile/reward-page/${params.id}`, {
        body: JSON.stringify(params.data)
      });

      if (response.ok) {
        const data = await response.json();
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        return data;
      }
      if (!response.ok) {
        thunksApi.dispatch(
          patchWheelProfileReward(params)
        );
      }

      return [];
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);

export const patchWheelProfileRewardTranslation = createAsyncThunk(
  "wheel/patch-wheel-profile-reward",
  async (params: {
    data: any,
    id: number
  }, thunksApi): Promise<WheelProfileRewards[]> => {
    try {
      const response = await agent.patch(`${DEFAULT_URL_V2}/profile/reward-page-translation/${params.id}`, {
        body: JSON.stringify(params.data)
      });

      if (response.ok) {
        const data = await response.json();
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        return data;
      }

      return [];
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);

export const postWheelProfileRewardTranslation = createAsyncThunk(
  "wheel/post-wheel-profile-reward",
  async (params: {
    data: any, id: number
  }, thunksApi): Promise<WheelProfileRewards[]> => {
    try {
      const response = await agent.post(`${DEFAULT_URL_V2}/profile/reward-page-translation/${params.id}`, {
        body: JSON.stringify(params.data)
      });

      if (response.ok) {
        const data = await response.json();
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        return data;
      }
      if (!response.ok) {
        thunksApi.dispatch(
          patchWheelProfileRewardTranslation(params)
        );
      }

      return [];
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);
